module.exports = __webpack_public_path__ + "media/images/icons/bullhorn-309cdc2223c71a232ea1b210fddf74f7.svg";